export default __webpack_public_path__ + "static/media/logo.2fd73ed1.png";